import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { LeadContatoPlanejado } from '../models/workflow.models';
import { buildSeedData } from './seed-data';

@Injectable({ providedIn: 'root' })
export class CrmService {
  private storageKey = 'wf_contatos';
  private contatosSubject = new BehaviorSubject<LeadContatoPlanejado[]>([]);

  constructor() {
    const stored = this.loadFromStorage();
    if (stored.length) {
      this.contatosSubject.next(stored);
    } else {
      const seed = buildSeedData();
      this.contatosSubject.next(seed.contatos);
      this.persist(seed.contatos);
    }
  }

  getAll(): Observable<LeadContatoPlanejado[]> {
    return this.contatosSubject.asObservable();
  }

  getEventosPorPeriodo(start: Date, end: Date): Observable<LeadContatoPlanejado[]> {
    return this.contatosSubject.asObservable().pipe(
      map((items) =>
        items.filter((item) => item.dataHora >= start && item.dataHora <= end)
      )
    );
  }

  addContatoPlanejado(contato: Omit<LeadContatoPlanejado, 'id' | 'concluido'>): void {
    const novo: LeadContatoPlanejado = {
      ...contato,
      id: Date.now(),
      concluido: false,
    };
    const updated = [...this.contatosSubject.value, novo];
    this.contatosSubject.next(updated);
    this.persist(updated);
  }

  marcarContatoConcluido(id: number): void {
    const updated = this.contatosSubject.value.map((item) =>
      item.id === id ? { ...item, concluido: true } : item
    );
    this.contatosSubject.next(updated);
    this.persist(updated);
  }

  private loadFromStorage(): LeadContatoPlanejado[] {
    if (typeof localStorage === 'undefined') {
      return [];
    }
    const raw = localStorage.getItem(this.storageKey);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw) as LeadContatoPlanejado[];
    return parsed.map((item) => ({ ...item, dataHora: new Date(item.dataHora) }));
  }

  private persist(items: LeadContatoPlanejado[]): void {
    if (typeof localStorage === 'undefined') {
      return;
    }
    localStorage.setItem(this.storageKey, JSON.stringify(items));
  }
}
